define.alias("shared/components/shared/mavely/links/mobile-tabs", "settings/components/shared/mavely/links/mobile-tabs");